import React, { useState } from 'react';
import axios from 'axios';
import Header from './Header';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '../siteConfig';
import { PolicyLink } from './SiteFooter';

function Page3() {
  const page1Data = JSON.parse(sessionStorage.getItem('page1Data') || '{}');
  const page2Data = JSON.parse(sessionStorage.getItem('page2Data') || '[]');
  const { fiscalYear, town, townCode, formType, ownerName, businessName, entityType,
    fidNumber, natureOfBusiness, stateOfFormation, dateOfFormation,
    businessAddress, legalResidence, propertyOwnership, mailingAddress,
    phone, email, propertyLocation } = page1Data;
  const isForm2 = formType === 'form_2';

  const [signerName, setSignerName] = useState('');
  const [signerTitle, setSignerTitle] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [agreedToLegal, setAgreedToLegal] = useState(false);
  const [representativeName, setRepresentativeName] = useState('');
  const [representativeEmail, setRepresentativeEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [filingReference, setFilingReference] = useState('');
  const [confirmedEmail, setConfirmedEmail] = useState('');

  const canSubmit = signerName && (!isForm2 || signerTitle) && agreedToTerms && agreedToLegal && !submitting;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const token = localStorage.getItem('token');

    const payload = {
      fiscal_year: parseInt(fiscalYear),
      town_code: townCode,
      town_or_city: town,
      form_type: formType,
      owner_name: ownerName,
      business_name: businessName || null,
      entity_type: entityType || null,
      fid_number: fidNumber || null,
      nature_of_business: natureOfBusiness || null,
      state_of_formation: stateOfFormation || null,
      date_of_formation: dateOfFormation || null,
      business_address: businessAddress || null,
      legal_residence: legalResidence || null,
      property_ownership: propertyOwnership || null,
      mailing_address: mailingAddress || null,
      phone: phone,
      email: email,
      property_location: propertyLocation,
      reported_items: page2Data.map(item => ({
        schedule: item.schedule,
        own_or_other: item.ownOrOther,
        description: item.description,
        quantity: item.quantity ? parseInt(item.quantity) : null,
        manufacturer: item.manufacturer || null,
        model: item.model || null,
        year_of_manufacture: item.yearOfManufacture ? parseInt(item.yearOfManufacture) : null,
        year_of_purchase: item.yearOfPurchase ? parseInt(item.yearOfPurchase) : null,
        purchase_price: item.purchasePrice ? parseFloat(item.purchasePrice) : null,
        estimated_market_value: item.estimatedMarketValue ? parseFloat(item.estimatedMarketValue) : null,
      })),
      signature: {
        signer_full_name: signerName,
        signer_title: signerTitle,
        agreed_to_terms: agreedToTerms,
        agreed_to_tos_and_privacy: agreedToLegal,
        legal_agreements_timestamp: new Date().toISOString(),
        representative_name: representativeName || null,
        representative_email: representativeEmail || null,
      },
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/filings/submit`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFilingReference(response.data.filing_reference);
      setConfirmedEmail(email);
      sessionStorage.clear();
    } catch (err) {
      setError('Submission failed. Please check your information and try again.');
      setSubmitting(false);
    }
  };

  if (filingReference) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>MAtownforms</h1>
          <div style={styles.successBox}>
            <h2 style={styles.successTitle}>✓ Filing Submitted Successfully</h2>
            <p style={styles.successText}>Your filing has been received and recorded. A confirmation email has been sent to {confirmedEmail}.</p>
            <h2 style={styles.successTitle}>Filing Number:</h2>
            <p style={styles.token}>{filingReference}</p>
            <button
              style={styles.button}
              onClick={() => window.location.href = '/my-filings'}
            >
              Back to My Account
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <Header step={3} />
        <p style={styles.meta}>
          {isForm2 ? 'Form 2 — Business' : 'Form 2HF — Second Home'} &nbsp;|&nbsp; {town} &nbsp;|&nbsp; FY{fiscalYear}
        </p>
        <h2 style={styles.subtitle}>Page 3 — Review and E-Sign</h2>

        <div style={styles.reviewSection}>
          <h3 style={styles.reviewTitle}>Filer Information</h3>
          <p style={styles.reviewItem}><strong>Name:</strong> {ownerName}</p>
          {businessName && <p style={styles.reviewItem}><strong>Business:</strong> {businessName}</p>}
          {entityType && <p style={styles.reviewItem}><strong>Entity Type:</strong> {entityType}</p>}
          {natureOfBusiness && <p style={styles.reviewItem}><strong>Nature of Business:</strong> {natureOfBusiness}</p>}
          {businessAddress && <p style={styles.reviewItem}><strong>Business Address:</strong> {businessAddress}</p>}
          {legalResidence && <p style={styles.reviewItem}><strong>Legal Residence:</strong> {legalResidence}</p>}
          <p style={styles.reviewItem}><strong>Property Location:</strong> {propertyLocation}</p>
          <p style={styles.reviewItem}><strong>Town:</strong> {town}</p>
          <p style={styles.reviewItem}><strong>Phone:</strong> {phone}</p>
          <p style={styles.reviewItem}><strong>Email:</strong> {email}</p>
        </div>

        <div style={styles.reviewSection}>
          <h3 style={styles.reviewTitle}>Reported Items ({page2Data.length})</h3>
          {page2Data.map((item, index) => (
            <div key={index} style={styles.reviewItem}>
              <strong>Schedule {item.schedule}</strong> — {item.description}
              {item.purchasePrice && ` — $${item.purchasePrice}`}
            </div>
          ))}
        </div>

        <div style={styles.reviewSection}>
          <h3 style={styles.reviewTitle}>E-Signature</h3>
          {error && <p style={styles.error}>{error}</p>}

          <form onSubmit={handleSubmit}>
            <div style={styles.field}>
              <label style={styles.label}>Full Legal Name of Authorized Signatory *</label>
              <input style={styles.input} type="text" value={signerName}
                onChange={(e) => setSignerName(e.target.value)} required />
            </div>

            {isForm2 && (
              <div style={styles.field}>
                <label style={styles.label}>Title *</label>
                <input style={styles.input} type="text" value={signerTitle}
                  onChange={(e) => setSignerTitle(e.target.value)} required />
              </div>
            )}

            <div style={styles.field}>
              <label style={styles.label}>Representative Name (if applicable)</label>
              <input style={styles.input} type="text" value={representativeName}
                onChange={(e) => setRepresentativeName(e.target.value)} />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Representative Email (if applicable)</label>
              <input style={styles.input} type="email" value={representativeEmail}
                onChange={(e) => setRepresentativeEmail(e.target.value)} />
            </div>

            <div style={styles.checkboxField}>
              <input type="checkbox" id="agree" checked={agreedToTerms}
                onChange={(e) => setAgreedToTerms(e.target.checked)} required />
              <label htmlFor="agree" style={styles.checkboxLabel}>
                This list, prepared or examined by me, includes all taxable personal property owned
                or held by the maker of this list on January 1 and to the best of my knowledge and
                belief, it and all accompanying schedules and statements are true, correct and
                complete. Subscribed under the penalties of perjury.
              </label>
            </div>

            <div style={styles.checkboxField}>
              <input type="checkbox" id="agreeLegal" checked={agreedToLegal}
                onChange={(e) => setAgreedToLegal(e.target.checked)} required />
              <label htmlFor="agreeLegal" style={styles.checkboxLabel}>
                I have read and agree to the{' '}
                <PolicyLink url={TERMS_OF_SERVICE_URL} style={styles.link}>Terms of Service</PolicyLink>
                {' '}and{' '}
                <PolicyLink url={PRIVACY_POLICY_URL} style={styles.link}>Privacy Policy</PolicyLink>.
              </label>
            </div>

            <button
              style={canSubmit ? styles.button : styles.buttonDisabled}
              type="submit"
              disabled={!canSubmit}
            >
              {submitting ? 'Submitting...' : 'E-Sign and Submit Filing'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '560px',
  },
  title: {
    color: '#1a3a5c',
    fontSize: '22px',
    marginBottom: '4px',
    textAlign: 'center',
  },
  meta: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#666',
    marginBottom: '8px',
  },
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  reviewSection: {
    marginBottom: '24px',
    borderTop: '1px solid #eee',
    paddingTop: '16px',
  },
  reviewTitle: {
    fontSize: '15px',
    color: '#1a3a5c',
    marginBottom: '10px',
  },
  reviewItem: {
    fontSize: '14px',
    color: '#333',
    marginBottom: '6px',
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  checkboxField: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '20px',
  },
  checkboxLabel: {
    fontSize: '13px',
    color: '#333',
    lineHeight: '1.5',
  },
  link: {
    color: '#1a3a5c',
    textDecoration: 'underline',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },
  buttonDisabled: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#aaa',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'not-allowed',
  },
  error: {
    color: '#cc0000',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  successBox: {
    textAlign: 'center',
    padding: '20px',
  },
  successTitle: {
    color: '#2e7d32',
    fontSize: '22px',
    marginBottom: '12px',
  },
  successText: {
    fontSize: '15px',
    color: '#333',
    marginBottom: '20px',
  },
  tokenLabel: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '6px',
  },
  token: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1a3a5c',
    backgroundColor: '#f4f6f9',
    padding: '12px',
    borderRadius: '4px',
    marginBottom: '12px',
    wordBreak: 'break-all',
  },
  successHint: {
    fontSize: '13px',
    color: '#666',
  },
};

export default Page3;